export enum PartnerCodes {
  CSS = 'css',
  SANITAS = 'sanitas',
  S24 = 's24',
  STAUFFACHER = 'stauffacher',
  LARS_KOSCHORRECK = 'larsKoschorreck',
  GYNPOINT = 'gynpoint',
  STEFAN_ZECHMANN = 'stefanZechmann',
}
